import React from "react";
import { Tooltip } from "@mantine/core";

interface CoordinatesType {
  longitude: number;
  latitude: number;
}
interface CurrentPositionType {
  onClick: (value: CoordinatesType) => void;
}

function CurrentPosition({ onClick }: CurrentPositionType) {
  const tooltipStyles = {
    tooltip: {
      backgroundColor: "white",
      color: "#323232",
      fontSize: "12px",
    },
  };

  const handleGetCurrentPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let coordinates = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        onClick(coordinates);
      });
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };

  return (
    <Tooltip label="ตำแหน่งปัจจุบัน" position="left" styles={tooltipStyles}>
      <button
        onClick={handleGetCurrentPosition}
        className="bg-primary-contrast duration-300 w-8 h-8 p-[5px] rounded-[10px] border-[1px] border-gray-1  flex gap-2"
      >
        <div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_1303_85978)">
              <path
                d="M10 7.27273C8.49318 7.27273 7.27273 8.49318 7.27273 10C7.27273 11.5068 8.49318 12.7273 10 12.7273C11.5068 12.7273 12.7273 11.5068 12.7273 10C12.7273 8.49318 11.5068 7.27273 10 7.27273ZM16.0955 9.31818C15.7818 6.475 13.525 4.21818 10.6818 3.90455V3.18182C10.6818 2.80682 10.375 2.5 10 2.5C9.625 2.5 9.31818 2.80682 9.31818 3.18182V3.90455C6.475 4.21818 4.21818 6.475 3.90455 9.31818H3.18182C2.80682 9.31818 2.5 9.625 2.5 10C2.5 10.375 2.80682 10.6818 3.18182 10.6818H3.90455C4.21818 13.525 6.475 15.7818 9.31818 16.0955V16.8182C9.31818 17.1932 9.625 17.5 10 17.5C10.375 17.5 10.6818 17.1932 10.6818 16.8182V16.0955C13.525 15.7818 15.7818 13.525 16.0955 10.6818H16.8182C17.1932 10.6818 17.5 10.375 17.5 10C17.5 9.625 17.1932 9.31818 16.8182 9.31818H16.0955ZM10 14.7727C7.36136 14.7727 5.22727 12.6386 5.22727 10C5.22727 7.36136 7.36136 5.22727 10 5.22727C12.6386 5.22727 14.7727 7.36136 14.7727 10C14.7727 12.6386 12.6386 14.7727 10 14.7727Z"
                fill="#8E8E8E"
              />
            </g>
            <defs>
              <clipPath id="clip0_1303_85978">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </button>
    </Tooltip>
  );
}

export default CurrentPosition;
